import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  items: [],
  itemData: {},
  currentItem: null
}

export const { actions, reducer } = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setItems: (state, action) => {
      state.items = action.payload
    },
    setItemData: (state, action) => {
      state.itemData = action.payload
    },
    setCurrentItem: (state, action) => {
      state.currentItem = action.payload
    },
    resetInventoryData: (state) => {
      state.items = []
      state.itemData = {}
      state.currentItem = null
    }
  }
})

export default reducer
